import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/w/$workspace/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/w/$workspace/overview", params })
  },
})
